import React from "react";
import Chart from "react-apexcharts";
import { COLOR_VENTAS, COLOR_COMPRAS } from "./constants";
import { formatCurrency } from "./utils";

export default function GraficoVentasCompras(props) {
    const moneda = props.moneda || "PEN";
    const timeLine = props.timeLine || [];
    const ventas = props.ventas || [];
    const compras = props.compras || [];
    const valorMaximo = Math.max(0, ...ventas, ...compras);

    const options = {
        chart: {
            type: "line",
            toolbar: { show: false },
            zoom: { enabled: false },
        },
        colors: [COLOR_VENTAS, COLOR_COMPRAS],
        stroke: { width: [3, 3], curve: "straight" },
        dataLabels: { enabled: false },
        markers: { size: 0 },
        xaxis: {
            categories: timeLine,
            tickAmount: 6,
            labels: { rotate: 0, hideOverlappingLabels: true },
            tooltip: { enabled: false },
        },
        yaxis: {
            min: 0,
            // Sin ventas ni compras se fija una escala para que el grafico
            // pinte sus ejes con la linea en 0.
            max: valorMaximo > 0 ? undefined : 100,
            tickAmount: 5,
            labels: {
                // Con montos chicos (< 1000) dividir entre 1000 siempre da "0K";
                // en ese caso se muestra el numero tal cual.
                formatter: (val) => (val >= 1000 ? `${Math.round(val / 1000)}K` : `${Math.round(val)}`),
            },
        },
        tooltip: {
            shared: true,
            intersect: false,
            y: {
                formatter: (val) => formatCurrency(val, moneda),
            },
        },
        legend: {
            position: "top",
            horizontalAlign: "center",
        },
        grid: { borderColor: "#eef0f2" },
    };

    const series = [
        { name: "Ventas", data: ventas },
        { name: "Compras", data: compras },
    ];

    // react-apexcharts compara las options con JSON.stringify, que ignora las
    // funciones: la key obliga a remontar cuando cambia la moneda (tooltip).
    return (
        <Chart key={moneda} options={options} series={series} type="line" height={300} />
    );
}
